const PURPLE = '#bf63f3';
const BLUE = '#1868db';
const GREEN = '#82b536';
const ORANGE = '#fca700';

export type LetterANode = {
	x: number;
	y: number;
	r: number;
	color: string;
};

export type LetterAEdge = readonly [number, number];

export const LETTER_A_VIEWBOX = {
	x: -6,
	y: -6,
	width: 122,
	height: 161,
} as const;

export const LETTER_A_OUTLINE_PATH =
	'm1.925 147.5 36.798-146H70.92l36.998 146H82.32l-8-35.4H35.524l-8 35.4zm38.198-55.8H69.72l-8.8-39.2a983 983 0 0 1-3.8-17.6q-1.6-8-2.2-11.6-.6 3.6-2.2 11.6-1.399 7.8-3.799 17.4z';

export const LETTER_A_NODES: LetterANode[] = [
	{ x: 35.66, y: 111.5, r: 6, color: BLUE },
	{ x: 40.11, y: 93.65, r: 6, color: ORANGE },
	{ x: 39.12, y: 1.5, r: 6, color: PURPLE },
	{ x: 55.11, y: 25.65, r: 6, color: BLUE },
	{ x: 74.36, y: 112.25, r: 6, color: PURPLE },
	{ x: 69.61, y: 92.65, r: 6, color: GREEN },
	{ x: 20.12, y: 75.5, r: 6, color: BLUE },
	{ x: 27.11, y: 148.64, r: 6, color: PURPLE },
	{ x: 71.11, y: 2.15, r: 6, color: GREEN },
	{ x: 81.61, y: 44.65, r: 6, color: PURPLE },
	{ x: 106.61, y: 147.14, r: 6, color: ORANGE },
	{ x: 1.12, y: 147.14, r: 6, color: GREEN },
];

export const LETTER_A_EDGES: LetterAEdge[] = [
	[0, 1],
	[1, 2],
	[2, 3],
	[1, 4],
	[4, 5],
	[1, 6],
	[6, 7],
	[3, 8],
	[3, 9],
	[9, 5],
	[5, 10],
];
